import { Box, Typography } from "@mui/material";

import RightContent from "components/wrappers/RightContent";

import { SequencingEstimatorPreference } from "./components/SequencingEstimatorPreference";

export const Preferences = () => {
  return (
    <RightContent>
      <Box display="flex" flexDirection="column" flexWrap="nowrap" gap="24px">
        <Typography variant="h1">Preferences</Typography>
        <SequencingEstimatorPreference />
      </Box>
    </RightContent>
  );
};
